import { useLocation } from 'react-router-dom';
import { MEMBER_WALLET_PATH, WALLET_DESTINATIONS } from '../../components/layout/navItems';
import { useTranslation } from 'react-i18next';
import { WalletCatalogSections } from './WalletCatalogSections';

export default function WalletConfigPage() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const destination =
    WALLET_DESTINATIONS.find(
      ({ section }) => pathname.replace(/\/+$/, '') === `${MEMBER_WALLET_PATH}/${section}`,
    ) ?? WALLET_DESTINATIONS[1];
  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold">{t(destination.label)}</h1>
      <WalletCatalogSections activeSection={destination.section} />
    </div>
  );
}
